import { SentenceType } from 'types/types'
import { computed, Ref } from 'vue'

const useResponsiveness = (sentences: Ref<Array<SentenceType>>) => {
  const sentencesHaveSameResponsiveness = computed<boolean>(() => {
    return sentences.value.every((sentence: SentenceType) => sentence.isResponsive === sentences.value[0].isResponsive)
  })

  return {
    sentencesHaveSameResponsiveness,
  }
}

export { useResponsiveness }
